var map = {
	"./discountkit-gwp-picker.js": 323,
	"./product-details.js": 258,
	"./product-options-picker.js": 761,
	"./size-guide.js": 844,
	"./stencil-element.js": 245,
	"./swiper-slider.js": 926
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 659;